import type { ChatRoom, ChatUser } from 'models';
import { useMemo } from 'react';
import { useGroupChatRoomInfo } from '../../../hooks';

type P = Pick<ChatRoom, 'name' | 'participants' | 'users'>;

export const useChatGroupInfo = ({
  name,
  participants,
  users,
}: P): {
  members: ChatUser[];
  membersCount: number;
  name: string;
} => {
  const { membersCount, name: groupName } = useGroupChatRoomInfo({
    name,
    participants,
    users,
  });

  return useMemo(
    () => ({
      members: users.flatMap((userId) => {
        const participant = participants[userId];

        if (!participant) {
          return [];
        }

        return [{ ...participant, id: userId }];
      }),
      membersCount,
      name: groupName,
    }),
    [groupName, membersCount, participants, users],
  );
};
